export default "__VITE_ASSET__BtDEAqOJ__"